import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from 'styles';
import { Routes } from 'routes';
import { ErrorModal } from 'components/ErrorModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const App = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes />
        <ErrorModal />
        <ToastContainer autoClose={5000} />
      </BrowserRouter>
    </ThemeProvider>
  );
};
